import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { NotificationService } from '../../core/services/notification-service/notification-service';

export const setPasswordGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const notificationService = inject(NotificationService);

  if (route.queryParams['token']) {
    return true;
  }

  notificationService.showTemporaryError(
    'Chybí odkaz pro nastavení hesla. Otevřete prosím odkaz z e-mailu znovu.',
    'Zavřít',
  );
  return router.createUrlTree(['/login']);
};
